type useConfluenceScopesProps = {
	isQuickSearchForWhiteboardsEnabled: boolean;
	isQuickSearchForDatabasesEnabled: boolean;
	isQuickSearchForSlidesEnabled: boolean;
};

type useConfluenceScopesType = {
	contentScope: string;
	extensibleScopes: string[];
};

export const useConfluenceScopes = ({
	isQuickSearchForWhiteboardsEnabled,
	isQuickSearchForDatabasesEnabled,
	isQuickSearchForSlidesEnabled,
}: useConfluenceScopesProps): useConfluenceScopesType => {
	let contentScope: string = 'confluence.page,blogpost,attachment,embed,folder';
	const spaceAndUserScope: string[] = ['confluence.space', 'urs.user-confluence'];

	if (isQuickSearchForWhiteboardsEnabled) {
		contentScope = `${contentScope},whiteboard`;
	}
	if (isQuickSearchForDatabasesEnabled) {
		contentScope = `${contentScope},database`;
	}
	if (isQuickSearchForSlidesEnabled) {
		contentScope = `${contentScope},slide`;
	}

	return {
		contentScope,
		extensibleScopes: [...[contentScope], ...spaceAndUserScope],
	};
};
